module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921134149_T.5042c071.jpg";